import React, { useState, useEffect } from 'react'
import Layout from '../../../brands/components/Layout'
import DataGrid from 'react-data-grid'
import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'
import AddNewType from '../../components/AddLeaveType'
import EditLeaveType from '../../components/EditLeaveType'
import DelLeaveType from '../../components/DelLeaveType'
import { getLeaveTypes } from '../api/index'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { useAppDispatch, useAppSelector } from '../../../../redux/hook'
import { EditLeaveTypeDetails } from '../types'
import { setLeaveTypes } from '../slice/index'

// import './index.css'

interface Row {
    id: string
    title: string
    numberOfLeaves: number
    isCarryOver: boolean
}

const LeaveTypes: React.FC = () => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const leaveTypesState = useAppSelector(
        (state) => state.leaveTypes.leaveTypes
    )
    const [showmodal, setShowModal] = useState<boolean>(false)
    const [editmodal, setShowEditModal] = useState<boolean>(false)
    const [delmodal, setShowDelModal] = useState<boolean>(false)
    const [editLeaveTypeDetails, setEditLeaveTypeDetails] =
        useState<EditLeaveTypeDetails>({
            leaveTypeName: '',
            leaveTypeId: '',
        })
    const [deleteLeaveTypeId, setDeleteLeaveTypeId] = useState<string>('')
    const [rows, setRows] = useState<Row[]>([])

    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(SHOW_LOADER())
                const response = await getLeaveTypes({})
                dispatch(setLeaveTypes(response?.data?.data || []))
                setRows(response?.data?.data)
            } catch (error) {
                console.error('Error fetching leave types:', error)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }

        fetchData()
    }, [])

    useEffect(() => {
        setRows(leaveTypesState)
    }, [leaveTypesState])

    const handleEditClick = (rowData: any) => {
        setEditLeaveTypeDetails({
            ...editLeaveTypeDetails,
            leaveTypeName: rowData?.title,
            leaveTypeId: rowData?.id,
        })
        setShowEditModal(true)
    }

    const handleDeleteClick = (rowData: any) => {
        setDeleteLeaveTypeId(rowData?.id)
        setShowDelModal(true)
    }

    const column = [
        {
            key: 'type',
            name: `Leave Type`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return <div>{props?.row?.title}</div>
            },
        },
        {
            key: 'Actions',
            name: `${t('brand.tableColumns.action')}`, // Fix the typo here
            resizable: true,
            sortable: true,
            renderCell: (props: any) => (
                <>
                    <div className="dropdown-custom-link">
                        <Icon
                            icon="ion:edit"
                            color="#39877C"
                            cursor={'pointer'}
                            onClick={() => {
                                handleEditClick(props.row)
                            }}
                        />
                        <Icon
                            onClick={() => {
                                handleDeleteClick(props.row)
                            }}
                            cursor={'pointer'}
                            icon="icon-park-outline:delete"
                            className="icon-secondary"
                        />
                    </div>
                </>
            ),
        },
    ]

    return (
        <div>
            <AddNewType show={showmodal} onClose={setShowModal} />
            <EditLeaveType
                show={editmodal}
                onClose={setShowEditModal}
                editLeaveTypeDetails={editLeaveTypeDetails}
            />
            <DelLeaveType
                show={delmodal}
                onClose={setShowDelModal}
                deleteLeaveTypeId={deleteLeaveTypeId}
            />
            <Layout>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h4>Leave Types Management</h4>
                            </div>
                            <div>
                                <div className="add-btns">
                                    <a
                                        onClick={() => {
                                            setShowModal(true)
                                        }}
                                        className="button button-primary"
                                    >
                                        ADD
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid-table-timeoff">
                        <DataGrid
                            key={rows.length}
                            className="data-grid-table "
                            columns={column}
                            // rowKeyGetter={(row: Brand) => row.id}
                            rows={rows}
                            rowHeight={60}
                            headerRowHeight={40}
                            // onCellClick={(row) => {
                            //     setSelectedBrand(row.row)
                            // }}
                            // sortColumns={sortColumns}
                            // onSortColumnsChange={setSortColumns}
                        />
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default LeaveTypes
